import React, { Component } from 'react';
import { Modal, Button, Tooltip, Pagination, Spin } from 'antd';
import { connect } from 'dva';
import router from 'umi/router';
import styles from './index.less';
import { getAppCode } from '../../../utils/utils';
import { getPathHeader } from '../../../../../../utils/utils';

@connect()
class CreateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      params: {
        page: 1,
        pageSize: 10,
        templateTitle: '',
      },
      totalElements: 0,
      spinning: false,
      id: '',
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchTemplateList(params);
  }

  fetchTemplateList = params => {
    const { dispatch } = this.props;
    this.setState({ spinning: true });
    dispatch({
      type: 'articleSubmissions/fetchTemplateList',
      params: {
        ...params,
        appCode: getAppCode(),
      },
    })
      .then(res => {
        this.setState({
          data: res.content,
          totalElements: res.totalElements,
          spinning: false,
        });
      })
      .catch(() => {
        this.setState({ spinning: false });
      });
  };

  btnClick = id => {
    this.setState(
      {
        id,
      },
      () => {
        setTimeout(() => {
          router.push(
            `/${getPathHeader()}/submissions/submissions/create?appCode=${getAppCode()}&newstype=0&moduleId=${id}`
          );
        }, 0);
      }
    );
  };

  onChange = (page, pageSize) => {
    const { params } = this.props;
    const tempParams = { ...params, page, pageSize };
    this.setState(
      {
        params: tempParams,
      },
      () => {
        this.fetchTemplateList(tempParams);
      }
    );
  };

  render() {
    const { showModal, nowArticleType, gotoOther, onCancel } = this.props;
    const { data, totalElements, params, spinning, id } = this.state;
    const { page } = params;
    return (
      <Modal
        visible={showModal}
        title="新建资讯"
        centered
        wrapClassName={styles.articleTypeModal}
        width="100%"
        footer={[]}
        onCancel={() => onCancel()}
      >
        <Spin spinning={spinning}>
          <div className="article-type-wrap">
            <div
              className={
                nowArticleType === 1
                  ? 'articleType active articleTypeCommon'
                  : 'articleType articleTypeCommon'
              }
              onClick={() => gotoOther(1)}
            >
              <div>
                <img src="https://s.xiaoyuanhao.com/image/micro/wenzhang_xinjian.png" alt="" />
                <h3>图文文章</h3>
              </div>
              <p>可直接在线编辑或者复制内容进入编辑器</p>
            </div>
            <div
              className={
                nowArticleType === 2
                  ? 'articleType active articleTypeCommon'
                  : 'articleType articleTypeCommon'
              }
              onClick={() => gotoOther(2)}
            >
              <div>
                <img src="https://s.xiaoyuanhao.com/image/micro/wenzhang_xinjian.png" alt="" />
                <h3>外链文章</h3>
              </div>
              <p>可将已发布的公众号文章链接进行推送</p>
            </div>
            {data.map(item => {
              return (
                <div
                  className={
                    item.id === id ? 'articleType module-wrap active' : 'articleType module-wrap '
                  }
                >
                  <div
                    className="module-bg-img"
                    style={{
                      backgroundImage: `url(${item.templateCoverPicFileIdUrl})`,
                    }}
                  >
                    <Button type="primary" onClick={() => this.btnClick(item.id)}>
                      使用模板
                    </Button>
                  </div>
                  <div className="module-title">
                    <Tooltip placement="top" title={item.templateTitle}>
                      <div className="module-title-text">{item.templateTitle}</div>
                    </Tooltip>
                  </div>
                </div>
              );
            })}
          </div>
          <Pagination
            showQuickJumper
            total={totalElements}
            current={page}
            showTotal={() => `共 ${totalElements} 条记录`}
            onChange={this.onChange}
          />
        </Spin>
      </Modal>
    );
  }
}
export default CreateModal;
